/* eslint-disable @typescript-eslint/indent */
import { createApi } from '@reduxjs/toolkit/query/react';
import { TServerResponse } from 'app/types/server-response';
import { transactionsBase } from 'app/utilities/env';
import getBaseQueryWithLogout from 'app/utilities/getBaseQuery';

import { FlutterwavecConfirmDTO, TTransaction } from '../types/transaction';

export const transactionsApi = createApi({
  reducerPath: 'transactionsApi',
  tagTypes: ['Transactions'],
  baseQuery: getBaseQueryWithLogout(transactionsBase),
  endpoints: (build) => ({
    getUserTransactions: build.query<TTransaction[], number>({
      query: (id) => `/transactions/${id}`,
      providesTags: ['Transactions'],
      transformResponse: (res: TServerResponse<TTransaction[]>) => res.data,
    }),

    confirmFlutterwaveTransaction: build.mutation<
      unknown,
      FlutterwavecConfirmDTO
    >({
      query: (body) => ({
        url: '/flw-response',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Transactions'],
      transformResponse: (res: TServerResponse<unknown>) => res.data,
    }),

    confirmPaystackTransaction: build.mutation<unknown, FlutterwavecConfirmDTO>(
      {
        query: (body) => ({
          url: '/paystack-response',
          method: 'POST',
          body,
        }),
        invalidatesTags: ['Transactions'],
        transformResponse: (res: TServerResponse<unknown>) => res.data,
      }
    ),
  }),
});

export const {
  useGetUserTransactionsQuery,
  useLazyGetUserTransactionsQuery,
  useConfirmFlutterwaveTransactionMutation,
  useConfirmPaystackTransactionMutation,
} = transactionsApi;
